var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 109,
    viewBox: "0 0 123 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5717 6.00001C57.6509 0.666672 65.3489 0.666667 68.4281 6L119.957 95.25C123.036 100.583 119.187 107.25 113.028 107.25H9.9714C3.813 107.25 -0.0360079 100.583 3.04319 95.25L54.5717 6.00001Z",
    stroke: "#FF3D3D",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5553 75.8882C59.1856 79.1232 63.8142 79.1232 64.4445 75.8882L70.9552 42.4755C72.1141 36.5279 67.5594 31 61.4999 31C55.4404 31 50.8857 36.5279 52.0446 42.4755L58.5553 75.8882Z",
    stroke: "#FF3D3D",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86C65 88.2091 63.2091 90 61 90C58.7909 90 57 88.2091 57 86C57 83.7909 58.7909 82 61 82C63.2091 82 65 83.7909 65 86Z",
    stroke: "#FF3D3D",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamacao);
export default __webpack_public_path__ + "static/media/exclamacao.30f976cfc19c7e9b595f6bd252971d57.svg";
export { ForwardRef as ReactComponent };